export default __webpack_public_path__ + "static/media/openouse.a73e4a84.jpg";